import { useState, useRef, useEffect } from 'react';
import { Button } from '../ui/button';

export function ReactionTest({ onScore }) {
  const [state, setState] = useState('idle');
  const [ms, setMs] = useState(null);
  const startRef = useRef(0);
  const timerRef = useRef(null);

  useEffect(() => () => clearTimeout(timerRef.current), []);

  const begin = () => {
    setMs(null);
    setState('waiting');
    timerRef.current = setTimeout(() => {
      startRef.current = performance.now();
      setState('go');
    }, 1200 + Math.random() * 2600);
  };

  const handleClick = () => {
    if (state === 'idle' || state === 'done' || state === 'early') {
      begin();
    } else if (state === 'waiting') {
      clearTimeout(timerRef.current);
      setState('early');
    } else if (state === 'go') {
      const elapsed = Math.round(performance.now() - startRef.current);
      setMs(elapsed);
      setState('done');
      onScore(elapsed);
    }
  };

  const bg = state === 'go' ? 'bg-emerald-500/90' : state === 'waiting' ? 'bg-rose-700/70' : 'bg-white/5';
  const text = {
    idle: 'Click to start',
    waiting: 'Wait for green...',
    go: 'CLICK NOW',
    done: `${ms} ms — click to retry`,
    early: 'Too early! Click to retry'
  }[state];

  return (
    <div className="space-y-4" data-testid="game-reaction-test">
      <p className="text-xs text-muted-foreground">Wait for the panel to turn green, then click as fast as you can. Lower is better.</p>
      <button
        type="button"
        onClick={handleClick}
        className={`w-full h-56 rounded-lg border border-white/10 flex items-center justify-center text-xl font-light transition-colors duration-150 ${bg}`}
        data-testid="reaction-panel"
      >
        {text}
      </button>
      {ms !== null && (
        <p className="text-center text-sm" data-testid="reaction-result">
          Your reaction: <span className="text-amber-300 tabular-nums">{ms} ms</span>
        </p>
      )}
      <Button variant="outline" className="rounded-full w-full" onClick={begin} data-testid="reaction-restart">
        Restart
      </Button>
    </div>
  );
}
